(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cta-banner"] && !Shopify.designMode) return;
  try {
    
  if (!window.__ga4ClickBound && !window.__indexItemCardsGa4Bound) {
    window.__ga4ClickBound = true;
    window.__indexItemCardsGa4Bound = true;

    document.addEventListener('click', function (event) {
      var target = event.target.closest('[data-ga4-event]');
      if (!target) return;

      var name = target.getAttribute('data-ga4-event');
      if (!name) return;

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name });
      } catch (error) {}

      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', name);
        }
      } catch (error) {}

      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(name, { event_name: name });
        }
      } catch (error) {}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ==== 検索トグル（SPのみ） 2026-09-01 ====
     SPのヘッダーを1段（53px）にしたので、2段目の検索窓はここで開閉する。
     ヘッダーの高さが変わるので、追従が隠れる量（--header-height）も入れ直す。
     入れ直さないと、検索を開いたまま下スクロールしたとき50pxだけ残る。 */
  (function () {
    function syncHeaderHeight(section) {
      if (section) {
        document.documentElement.style.setProperty('--header-height', section.offsetHeight + 'px');
      }
    }

    function setOpen(header, open) {
      var button = header.querySelector('[data-search-toggle]');
      header.classList.toggle('header--search-open', open);
      if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
      syncHeaderHeight(header.closest('.section-header'));

      if (open) {
        var input = header.querySelector('#Search-Inline, .header__search-row input[type="search"]');
        if (input) input.focus();
      } else if (button) {
        button.focus();
      }
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-search-toggle]');
      if (!button) return;
      var header = button.closest('.header--custom');
      if (!header) return;
      setOpen(header, !header.classList.contains('header--search-open'));
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var header = document.querySelector('.header--custom.header--search-open');
      if (header) setOpen(header, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-item-cards"] && !Shopify.designMode) return;
  try {
    
  if (!window.__indexItemCardsGa4Bound) {
    window.__indexItemCardsGa4Bound = true;

    document.addEventListener('click', function (event) {
      var target = event.target.closest('[data-ga4-event]');
      if (!target) return;

      var name = target.getAttribute('data-ga4-event');
      if (!name) return;

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name });
      } catch (error) {}

      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', name);
        }
      } catch (error) {}

      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(name, { event_name: name });
        }
      } catch (error) {}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intro-video-overlay"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('intro-video-overlay')) {
    customElements.define(
      'intro-video-overlay',
      class IntroVideoOverlay extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          const first = document.querySelector('intro-video-overlay');
          if (first != null && first !== this) {
            this.setAttribute('dismissed', '');
            this.setAttribute('aria-hidden', 'true');
            return;
          }

          this.video = this.querySelector('video');
          this.unmuteBtn = this.querySelector('.intro-video-overlay__unmute');
          this.skipBtn = this.querySelector('.intro-video-overlay__skip');
          this.labels = {
            unmute: this.dataset.labelUnmute,
            mute: this.dataset.labelMute,
          };

          if (!this.video) {
            this.dismiss();
            return;
          }

          this.video.muted = true;
          this.video.defaultMuted = true;
          this.video.playsInline = true;
          this.video.loop = false;
          this.video.controls = false;
          this.video.setAttribute('playsinline', '');
          this.video.setAttribute('webkit-playsinline', '');
          this.video.disablePictureInPicture = true;

          document.documentElement.classList.add('intro-video-overlay-lock');
          this.tryPlay();

          this.unmuteBtn.addEventListener('click', () => this.toggleMute());
          this.skipBtn.addEventListener('click', () => this.dismiss());
          this.video.addEventListener('ended', () => this.dismiss());
        }

        tryPlay() {
          const playPromise = this.video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }

        toggleMute() {
          this.video.muted = !this.video.muted;
          if (this.video.muted) {
            this.unmuteBtn.setAttribute('aria-pressed', 'false');
            this.unmuteBtn.setAttribute('aria-label', this.labels.unmute);
          } else {
            this.unmuteBtn.setAttribute('aria-pressed', 'true');
            this.unmuteBtn.setAttribute('aria-label', this.labels.mute);
            this.tryPlay();
          }
        }

        dismiss() {
          if (this.hasAttribute('dismissed')) return;
          this.setAttribute('dismissed', '');
          this.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('intro-video-overlay-lock');
          if (this.video) {
            this.video.pause();
            this.video.muted = true;
          }
        }

        disconnectedCallback() {
          document.documentElement.classList.remove('intro-video-overlay-lock');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-bannerlists"] && !Shopify.designMode) return;
  try {
    
  if (!window.__ga4ClickBound && !window.__indexItemCardsGa4Bound) {
    window.__ga4ClickBound = true;
    window.__indexItemCardsGa4Bound = true;

    document.addEventListener('click', function (event) {
      var target = event.target.closest('[data-ga4-event]');
      if (!target) return;

      var name = target.getAttribute('data-ga4-event');
      if (!name) return;

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name });
      } catch (error) {}

      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', name);
        }
      } catch (error) {}

      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(name, { event_name: name });
        }
      } catch (error) {}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-floating-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-floating-video')) {
    customElements.define(
      'product-floating-video',
      class ProductFloatingVideo extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.video = this.querySelector('video');
          this.expandBtn = this.querySelector('.product-floating-video__expand');
          this.minimizeBtn = this.querySelector('.product-floating-video__minimize');
          this.chipBtn = this.querySelector('.product-floating-video__chip');
          this.toggleBtn = this.querySelector('.product-floating-video__toggle');
          this.closeBtn = this.querySelector('.product-floating-video__close');
          this.storageKey = this.dataset.storageKey;
          this.labels = {
            expand: this.dataset.labelExpand,
            play: this.dataset.labelPlay,
            pause: this.dataset.labelPause,
            close: this.dataset.labelClose,
            minimize: this.dataset.labelMinimize,
          };

          if (!this.video) return;

          this.video.muted = true;
          this.video.defaultMuted = true;
          this.video.playsInline = true;
          this.video.setAttribute('playsinline', '');
          this.video.setAttribute('webkit-playsinline', '');
          this.video.controls = false;
          this.video.disablePictureInPicture = true;
          this.applyAspect();
          this.video.addEventListener('loadedmetadata', () => this.applyAspect());

          this.expandBtn.addEventListener('click', () => this.expand());
          this.minimizeBtn.addEventListener('click', (event) => {
            event.stopPropagation();
            this.minimize();
          });
          this.chipBtn.addEventListener('click', () => this.restore());
          this.toggleBtn.addEventListener('click', () => this.togglePlayback());
          this.closeBtn.addEventListener('click', () => this.collapse());
          this.video.addEventListener('play', () => this.syncPlayingState());
          this.video.addEventListener('pause', () => this.syncPlayingState());
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.hasAttribute('expanded')) {
              event.preventDefault();
              this.collapse();
            }
          });

          this.syncPlayingState();

          try {
            if (this.storageKey && sessionStorage.getItem(this.storageKey) === '1') {
              this.minimize();
              return;
            }
          } catch (error) {}

          this.tryPlay();
        }

        applyAspect() {
          const width = this.video.videoWidth;
          const height = this.video.videoHeight;
          if (!width || !height) return;
          const ratio = width / height;
          this.style.setProperty('--pfv-ratio', String(ratio));
          this.dataset.orientation = ratio < 1 ? 'portrait' : 'landscape';
        }

        tryPlay() {
          const playPromise = this.video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }

        syncPlayingState() {
          if (this.video.paused) {
            this.removeAttribute('playing');
            this.toggleBtn.setAttribute('aria-label', this.labels.play);
          } else {
            this.setAttribute('playing', '');
            this.toggleBtn.setAttribute('aria-label', this.labels.pause);
          }
        }

        expand() {
          this.removeAttribute('minimized');
          this.setAttribute('expanded', '');
          this.setAttribute('role', 'dialog');
          this.setAttribute('aria-modal', 'true');
          this.setAttribute('aria-label', this.labels.expand);
          document.documentElement.classList.add('product-floating-video-lock');
          this.video.muted = false;
          this.tryPlay();
          this.closeBtn.focus();
        }

        collapse() {
          this.removeAttribute('expanded');
          this.removeAttribute('role');
          this.removeAttribute('aria-modal');
          this.removeAttribute('aria-label');
          document.documentElement.classList.remove('product-floating-video-lock');
          this.video.muted = true;
          this.tryPlay();
          this.expandBtn.focus();
        }

        minimize() {
          this.removeAttribute('expanded');
          this.removeAttribute('role');
          this.removeAttribute('aria-modal');
          this.removeAttribute('aria-label');
          document.documentElement.classList.remove('product-floating-video-lock');
          this.setAttribute('minimized', '');
          this.video.muted = true;
          this.video.pause();
          try {
            if (this.storageKey) sessionStorage.setItem(this.storageKey, '1');
          } catch (error) {}
          this.chipBtn.focus();
        }

        restore() {
          this.removeAttribute('minimized');
          try {
            if (this.storageKey) sessionStorage.removeItem(this.storageKey);
          } catch (error) {}
          this.tryPlay();
          this.expandBtn.focus();
        }

        togglePlayback() {
          if (this.video.paused) {
            this.tryPlay();
          } else {
            this.video.pause();
          }
        }

        disconnectedCallback() {
          document.documentElement.classList.remove('product-floating-video-lock');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["short-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('short-video')) {
    customElements.define(
      'short-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.muteBtn = this.querySelector('[data-svid-mute]');
          this.startBtn = this.querySelector('[data-svid-start]');
          this.scrim = this.querySelector('[data-svid-scrim]');
          if (!this.video) return;
          this.prepare();
          this.bindEvents();
        }

        bindEvents() {
          if (this.hasBoundEvents) return;
          this.hasBoundEvents = true;

          if (this.muteBtn) {
            this.muteBtn.addEventListener('click', this.onMuteClick.bind(this));
          }
          if (this.startBtn) {
            this.startBtn.addEventListener('click', this.onStartClick.bind(this));
          }
          if (this.scrim) {
            this.scrim.addEventListener('click', this.onStartClick.bind(this));
          }
          this.addEventListener('click', this.onRootClick.bind(this));
          this.video.addEventListener('ended', this.onEnded.bind(this));
        }

        onMuteClick(event) {
          event.preventDefault();
          event.stopPropagation();
          this.toggleMute();
        }

        onStartClick(event) {
          event.preventDefault();
          event.stopPropagation();
          this.play();
        }

        onRootClick(event) {
          if (event.target.closest('[data-svid-mute]')) return;
          if (event.target.closest('[data-svid-start]')) return;
          if (event.target.closest('[data-svid-scrim]')) return;
          if (this.classList.contains('is-playing')) this.pause();
        }

        onEnded() {
          if (this.getAttribute('data-svid-loop') === 'true') return;
          this.classList.remove('is-playing');
          try {
            this.video.currentTime = 0;
          } catch (error) {}
        }

        isMuted() {
          return this.classList.contains('is-muted');
        }

        syncMute() {
          var muted = this.isMuted();
          this.video.muted = muted;
          this.video.defaultMuted = muted;
          if (muted) {
            this.video.setAttribute('muted', '');
          } else {
            this.video.removeAttribute('muted');
          }
          if (this.muteBtn) {
            this.muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
            this.muteBtn.setAttribute('aria-label', muted ? 'ミュート解除' : 'ミュート');
          }
        }

        toggleMute() {
          this.classList.toggle('is-muted');
          this.syncMute();
        }

        prepare() {
          this.video.loop = this.getAttribute('data-svid-loop') === 'true';
          this.video.controls = false;
          this.video.playsInline = true;
          this.video.setAttribute('playsinline', '');
          this.video.setAttribute('webkit-playsinline', '');
          this.syncMute();
        }

        play() {
          this.prepare();
          var play = this.video.play();
          var root = this;
          function onStart() {
            root.classList.add('is-playing');
          }
          if (play && typeof play.then === 'function') {
            play.then(onStart).catch(function () {});
          } else {
            onStart();
          }
        }

        pause() {
          this.video.pause();
          this.classList.remove('is-playing');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('split-hero-slider')) {
    customElements.define(
      'split-hero-slider',
      class SplitHeroSlider extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.index = Math.max(
            0,
            this.slides.findIndex(function (slide) {
              return slide.classList.contains('is-active');
            })
          );
          if (this.index < 0) this.index = 0;
          this.timer = null;
          this.boundVideo = null;
          this.autoplay = this.dataset.autoplay === 'true';
          this.interval = Number(this.dataset.interval || 5000);

          this.next = this.next.bind(this);
          this.onVideoEnded = this.onVideoEnded.bind(this);

          this.observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(
                function (entry) {
                  if (entry.isIntersecting) {
                    this.inView = true;
                    this.syncVideos(false);
                    this.start();
                  } else {
                    this.inView = false;
                    this.stop();
                    this.pauseAllVideos();
                  }
                }.bind(this)
              );
            }.bind(this),
            { threshold: 0.35 }
          );
          this.observer.observe(this);

          this.muteVideos();
          this.syncVideos(false);
          this.start();
          this.observeFloat();
        }

        disconnectedCallback() {
          this.stop();
          if (this.observer) this.observer.disconnect();
          if (this.floatObserver) this.floatObserver.disconnect();
        }

        observeFloat() {
          var list = this.querySelector('[data-sh-float]');
          if (!list) return;
          this.floatObserver = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) entry.target.classList.add('is-in');
              });
            },
            { threshold: 0.35 }
          );
          this.floatObserver.observe(list);
        }

        isSingleSlide() {
          return this.slides.length < 2;
        }

        next() {
          this.stop();
          this.goTo(this.index + 1);
          this.start();
        }

        onVideoEnded() {
          if (this.isSingleSlide()) {
            this.replayActiveVideo();
            return;
          }
          this.next();
        }

        goTo(next) {
          if (this.isSingleSlide()) {
            this.replayActiveVideo();
            return;
          }
          var total = this.slides.length;
          this.index = ((next % total) + total) % total;
          this.slides.forEach(
            function (slide, i) {
              var active = i === this.index;
              slide.classList.toggle('is-active', active);
              slide.setAttribute('aria-hidden', active ? 'false' : 'true');
            }.bind(this)
          );
          this.syncVideos(true);
        }

        start() {
          this.stop();
          if (this.inView === false) return;

          var slide = this.slides[this.index];
          var video = slide ? slide.querySelector('video') : null;

          if (video) {
            video.loop = this.isSingleSlide();
            this.playVideo(video, false);
            if (this.isSingleSlide()) return;

            this.boundVideo = video;
            video.addEventListener('ended', this.onVideoEnded);
            this.onMeta = function () {
              var remaining = this.interval;
              if (isFinite(video.duration) && video.duration > 0) {
                remaining = Math.max(0.25, video.duration - (video.currentTime || 0)) * 1000 + 400;
              }
              if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
              }
              this.timer = setTimeout(this.next, remaining);
            }.bind(this);
            if (isFinite(video.duration) && video.duration > 0) {
              this.onMeta();
            } else {
              video.addEventListener('loadedmetadata', this.onMeta);
              this.timer = setTimeout(this.next, 60000);
            }
            return;
          }

          if (!this.autoplay || this.isSingleSlide()) return;
          this.timer = setTimeout(this.next, this.interval);
        }

        stop() {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          if (this.boundVideo) {
            this.boundVideo.removeEventListener('ended', this.onVideoEnded);
            if (this.onMeta) {
              this.boundVideo.removeEventListener('loadedmetadata', this.onMeta);
              this.onMeta = null;
            }
            this.boundVideo = null;
          }
        }

        muteVideos() {
          var loopSingle = this.isSingleSlide();
          this.querySelectorAll('video').forEach(function (video) {
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.setAttribute('muted', '');
            video.setAttribute('playsinline', '');
            video.loop = loopSingle;
            video.controls = false;
          });
        }

        pauseAllVideos() {
          this.querySelectorAll('video').forEach(function (video) {
            video.pause();
          });
        }

        playVideo(video, reset) {
          if (reset || video.ended) {
            try {
              video.currentTime = 0;
            } catch (error) {}
          }
          var play = video.play();
          if (play && typeof play.catch === 'function') play.catch(function () {});
        }

        replayActiveVideo() {
          var slide = this.slides[this.index];
          var video = slide ? slide.querySelector('video') : null;
          if (!video) return;
          video.loop = true;
          this.playVideo(video, true);
        }

        syncVideos(reset) {
          this.muteVideos();
          this.slides.forEach(
            function (slide, i) {
              var video = slide.querySelector('video');
              if (!video) return;
              if (i === this.index && this.inView !== false) {
                this.playVideo(video, Boolean(reset) && !this.isSingleSlide());
              } else {
                video.pause();
              }
            }.bind(this)
          );
        }
      }
    );
  }

  if (!window.__ga4ClickBound && !window.__indexItemCardsGa4Bound) {
    window.__ga4ClickBound = true;
    window.__indexItemCardsGa4Bound = true;

    document.addEventListener('click', function (event) {
      var target = event.target.closest('[data-ga4-event]');
      if (!target) return;

      var name = target.getAttribute('data-ga4-event');
      if (!name) return;

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name });
      } catch (error) {}

      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', name);
        }
      } catch (error) {}

      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(name, { event_name: name });
        }
      } catch (error) {}
    });
  }

  } catch(e) { console.error(e); }
})();
})();
